import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const refundAndFailBankTransferInstallmentOperation = async (
  userId: number,
  installmentPlanId: number,
  installmentId: number,
  cancelReasonId: number,
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
): Promise<boolean> => {
  try {
    setLoading(true);

    const res = await appApi.refundAndFailInstallmentBankTransfer(
      userId,
      installmentPlanId,
      installmentId,
      cancelReasonId,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    toast.success('הפעולה בוצעה בהצלחה');
    setLoading(false);
    onSuccess();
    return true;
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
    return false;
  }
};
